export default {
  workareaHeight: ""
};
